import React, { useState, useEffect } from "react";
import {
  Accordion,
  Box,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { UseProductGroup } from "../../basic-information/productGroup/UseProductGroup";
import { UseProduct } from "./UseProduct";
import { useSnackbar } from "notistack";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { rsProgress, rsParentChilds } from "../../RecoilStates";
import ProductGroupsChilds from "../../basic-information/productGroup/ProductGroupsChilds";
import { useRecoilState } from "recoil";
import CustomPagination from "../../components/CustomPagination";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditLevel4(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const { getGroupList } = UseProductGroup();
  const [filtered, setFiltered] = useState([]);
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [searchToShow, setSearchToShow] = useState("");
  const { validateLvl4Edit } = UseProduct();
  const [stateValidation, setStateValidation] = useState({
    groupID: false,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setProgress(true);
    getGroupList(
      searchToShow,
      (productgroups) => {
        setProgress(false);
        setFiltered(productgroups.productGroups);
      },
      false
    );
  }, [searchToShow]);

  const [level4, setLevel4] = React.useState({
    groupID: props.product.groupID,
  });

  function gotStoreId(id, faName) {
    setLevel4({ groupID: id });

    enqueueSnackbar("گروه (( " + [faName] + "  )) با موفقیت  انتخاب شد .", {
      variant: "success",
      autoHideDuration: 3000,
      preventDuplicate: true,
    });
  }

  useEffect(() => {
    if (props.fire) {
      Validation4();
    }
  }, [props.fire]);

  const columns = [
    {
      field: "id",
      width: 60,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: 180,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 70,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Childs">
            <IconButton
              onClick={() => {
                setParentID({
                  id: cellValues.row.id,
                  name: cellValues.row.faName,
                });
              }}
            >
              <ArrowLeftIcon sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "name",
      sortable: false,
      width: 330,
      headerName: "انتخاب",
      headerAlign: "left",
      renderHeader: (cellValues) => {
        return (
          <Box>
            <Typography variant="caption" color="inherit">
              گروه فعال: {props.product.fullGroupName}
            </Typography>
          </Box>
        );
      },
    },
  ];

  return (
    <Accordion
      expanded={props.expanded === "panel4"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        onClick={() => props.setExpanded("panel4")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography>مرحله چهارم</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ height: "40rem !important" }}>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از اتمام ویرایش محصول اطمینان دارید ؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => props.setFire(true)}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setOpen(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={3}
          sx={{ height: "31rem !important", mb: 10 }}
        >
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <TextField
                placeholder="جستجو گروه"
                size="small"
                sx={{ mb: 2, width: isSmall ? "75%" : "40%" }}
                variant="outlined"
                value={searchToShow}
                inputProps={{ "aria-label": "search" }}
                onChange={(evt) => {
                  setParentID({
                    id: null,
                    name: "",
                  });
                  setSearchToShow(evt.target.value);
                }}
              />
              <Box>
                <IconButton
                  sx={{ p: 0, m: 1 }}
                  onClick={() => {
                    setProgress(true);
                    getGroupList(
                      searchToShow,
                      (productgroups) => {
                        setProgress(false);
                        setFiltered(productgroups.productGroups);
                      },
                      false
                    );
                  }}
                >
                  <CachedIcon />
                </IconButton>
                <IconButton sx={{ p: 0 }} href="/productgroups" target="_blank">
                  <LinkIcon />
                </IconButton>
              </Box>
            </Box>
            <DataGrid
              disableVirtualization
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !Important",
                },
                "& .MuiDataGrid-cell:hover": {
                  color: "primary.main",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
                "& .primary": {
                  width: "100%",
                  backgroundColor: "#ECF6E7 !important",
                },
                "& .none": {
                  width: "100%",
                  backgroundColor: "#fff !important",
                },
                "& .secondary": {
                  width: "100%",
                  backgroundColor: "secondary !important",
                },
              }}
              getRowClassName={(params) => {
                if (params.row.id == parentID.id) {
                  return "primary";
                }
                if (params.row.id !== parentID.id) {
                  return "none";
                }
                if (params.row.id == props.product.groupID) {
                  return "secondary";
                }
              }}
              columns={columns}
              rows={filtered ? filtered : []}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              hideFooter
            />
          </Box>
          <Box
            sx={{ mt: isSmall ? 7 : 0 }}
            gridColumn={isSmall ? "span 12" : "span 6"}
          >
            <ProductGroupsChilds
              searchToShow={searchToShow}
              setSearchToShow={setSearchToShow}
              parentID={parentID}
              ProductGroup
              groupID={level4.groupID}
              setGroupID={gotStoreId}
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              props.setExpanded("panel3");
            }}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            اتمام
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => Validation4()}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function Validation4() {
    validateLvl4Edit(
      level4,
      setStateValidation,
      (res) => {
        if (props.fire == false) {
          enqueueSnackbar("مرحله چهارم با موفقیت تکمیل شد", {
            variant: "success",
            autoHideDuration: 2000,
          });
          props.setExpanded("panel5");
        }
        props.fill(level4);
      },
      props.setFire
    );
  }
}
